var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg"},[_vm._m(0),_c('server-bank',{attrs:{"productId":this.$route.query.productId}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('img',{staticClass:"success",attrs:{"src":require("@/assets/images/success.png"),"alt":"成功"}}),_c('p',[_vm._v("电核中...")]),_c('p',[_vm._v("\n      支用申请前需要电核，核实申请人信息，请联系您的客户经理处理。\n    ")])])
}]

export { render, staticRenderFns }